import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslationService } from 'src/app/services/translation.service';
import { ExamViolationsService } from 'src/app/services/exam-violations.service';
import { PDFDocument} from 'pdf-lib';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import fontkit from '@pdf-lib/fontkit';

@Component({
  selector: 'app-exam-violations',
  imports: [CommonModule,FormsModule],
  templateUrl: './exam-violations.component.html',
  styleUrl: './exam-violations.component.css'
})

export class ExamViolationsComponent {

  currentDate = new Date();
  currentUser: string = '';
  currentEmail: string = '';
  ExamInvigilatorName: string = '';
  IncidentInformation: string = '';
  ActionTaken: string = '';

  candidatesCurrentlyTesting: any[] = [];
  selectedCandidate = {};
  reportedCandidates: any[] = [];
  reportedModal: boolean = false;
  candidateModal: boolean = false;


  widgets: { title: string; count: number; colorClass: string; data: any[] }[] = [
    { title: 'Reported Candidates', count: 0, colorClass: 'text-primary', data: [] },
  ];

  constructor(private examViolations: ExamViolationsService, public translationService: TranslationService, private http: HttpClient) {}

  ngOnInit() {
    const keys = Object.keys(sessionStorage);
    keys.forEach((key) => {
      const value = sessionStorage.getItem(key);
      if (value !== null) {
        try {
          const parsedValue = JSON.parse(value);
            if (parsedValue && parsedValue.authorityType === "MSSTS") {
              this.currentUser = parsedValue.name
              this.currentEmail = parsedValue.username
          }
          } catch (e) {
          }
      }
    });

    this.getTodayExamViolations();
    this.getCandidatesCurrentlyTesting();
  }

  getTodayExamViolations(){
    this.examViolations.getTodayExamViolations().subscribe(
      (response: any) => {
        this.widgets[0].data = response.result[0]
        this.widgets[0].count = response.result[1]
      },
    );
  }

  getCandidatesCurrentlyTesting(){
    this.examViolations.getCandidatesCurrentlyTesting().subscribe(
      (response: any) => {
        if (response.result[0].length >= 1) {
          this.candidatesCurrentlyTesting = response.result[0];
        } else {
          this.candidatesCurrentlyTesting = [];
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  openModal(data: any) {
    if (data.data) {
      this.reportedModal = true
      this.reportedCandidates = data.data;
    }else{
      this.candidateModal = true;
      this.selectedCandidate = data
    }
  }

  closeModal() {
    this.selectedCandidate = {};
    this.reportedCandidates = [];
    this.candidateModal = false
    this.reportedModal = false
    this.ExamInvigilatorName = '';
    this.IncidentInformation = '';
    this.ActionTaken = '';
    this.getCandidatesCurrentlyTesting();
    this.getTodayExamViolations();
  }
  
  createReport() {

    const reportData = {
      ...this.selectedCandidate, 
      currentDate: this.currentDate,
      supervisorName: this.currentUser,
      supervisorEmail: this.currentEmail,
      examInvigilatorName: this.ExamInvigilatorName,
      incidentInformation: this.IncidentInformation,
      actionTaken: this.ActionTaken,
    };

    if (this.ExamInvigilatorName && this.IncidentInformation && this.ActionTaken) {
      this.examViolations.createNewViolationReport(reportData).subscribe((response: any) => {
        this.closeModal();
      });
    }

  }

  async viewReport(report: any) {
    const data = {
      TraineeName: report.TraineeName,
      IDNumber: report.IDNumber,
      BranchCity: report.BranchCity,
      CreateDate: new Date(report.CreateDate || new Date()).toLocaleString(),
      ExamSupervisorName: report.ExamSupervisorName || this.currentUser,
      ExamInvigilatorName: report.ExamInvigilatorName || this.ExamInvigilatorName,
      IncidentInformation: report.IncidentInformation || this.IncidentInformation,
      ActionTaken: report.ActionTaken || this.ActionTaken
    };

    
    const [pdfBytes, fontBytes] = await Promise.all([
      firstValueFrom(this.http.get('assets/attachments/Reported_Candidate.pdf', { responseType: 'arraybuffer' })),
      firstValueFrom(this.http.get('assets/fonts/Cairo-Bold.ttf', { responseType: 'arraybuffer' }))
    ]);

    const pdfDoc = await PDFDocument.load(pdfBytes);
    pdfDoc.registerFontkit(fontkit);

    const arabicFont = await pdfDoc.embedFont(fontBytes, { subset: true });

    const form = pdfDoc.getForm();

    const courseName = report.CourseName?.trim();

    switch (courseName) {
      case 'Food Safety':
        form.getCheckBox('fs_checkbox').check();
        break;
      case 'Barbershops':
        form.getCheckBox('br_checkbox').check();
        break;
      case 'Laundry':
        form.getCheckBox('la_checkbox').check();
        break;
      case 'Beauty Salons':
        form.getCheckBox('bs_checkbox').check();
        break;
      default:
        console.warn(`❗ CourseName "${courseName}" not recognized`);
        break;
    }

  
    Object.entries(data).forEach(([key, value]) => {
      try {
        const field = form.getTextField(key);
        field.setText(String(value));
        field.updateAppearances(arabicFont); 
      } catch {
        console.warn(`❗ Field ${key} not found in PDF`);
      }
    });

    const filledPdf = await pdfDoc.save();
    const blob = new Blob([filledPdf], { type: 'application/pdf' });
    saveAs(blob, `Violation_Report_${report.IDNumber || 'unknown'}.pdf`);
  }

}
